import {
  CalendarOutlined,
  DollarOutlined,
  FileTextOutlined,
  HistoryOutlined,
  PercentageOutlined,
  PictureOutlined,
  UnorderedListOutlined
} from "@ant-design/icons"
import { Flex, Radio } from "antd"
import React, { useMemo } from "react"

import { type PermissionProjectPermissions } from "../../../SettingsPermissions/types/permissions.types.ts"
import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import {
  type ProjectSectionKeys as Keys,
  getVisibleProjectTabs
} from "../../helpers/project-visible-tabs.ts"

export const projectViewTabs: Array<{
  icon: React.ReactNode
  label: string
  value: Keys
}> = [
  {
    icon: <CalendarOutlined />,
    label: "Milestones",
    value: "milestones"
  },
  {
    icon: <DollarOutlined />,
    label: "Finance",
    value: "finance"
  },
  {
    icon: <FileTextOutlined />,
    label: "Invoices",
    value: "invoices"
  },
  {
    icon: <UnorderedListOutlined />,
    label: "Tasks",
    value: "tasks"
  },
  {
    icon: <PercentageOutlined />,
    label: "Commissions",
    value: "commissions"
  },
  {
    icon: <PictureOutlined />,
    label: "Albums",
    value: "albums"
  },
  {
    icon: <HistoryOutlined />,
    label: "Logs",
    value: "logs"
  }
]

export type { ProjectSectionKeys } from "../../helpers/project-visible-tabs.ts"

interface ProjectViewSectionsProps {
  permissions: PermissionProjectPermissions | undefined
  activeTab: Keys | null
  onSectionChange: (value: Keys) => void
}

export function ProjectViewSectionsTabs({
  permissions,
  activeTab,
  onSectionChange
}: ProjectViewSectionsProps) {
  const roleId = useAppSelector((state) => state.auth.userInfo?.role?.id)

  const tabs = useMemo(() => {
    const visible = getVisibleProjectTabs(permissions, roleId)
    return projectViewTabs.filter((t) => visible.includes(t.value))
  }, [permissions, roleId])

  if (!tabs?.length) return null

  return (
    <div className={"sticky top-0 z-10 bg-background"}>
      <Radio.Group
        value={activeTab ?? undefined}
        onChange={(e) => onSectionChange(e.target.value)}
        buttonStyle="solid"
        optionType={"button"}
        className={
          "flex w-full bg-[var(--ant-radio-button-bg)] border border-border rounded-[9px] p-1"
        }
        options={tabs?.map((tab) => ({
          ...tab,
          className: "flex-1 border-none rounded-[var(--ant-border-radius)]",
          label: (
            <Flex align={"center"} justify={"center"} gap={"small"}>
              {tab.icon} {tab.label}
            </Flex>
          )
        }))}
      />
      {/*<Segmented<ProjectSectionKeys>*/}
      {/*  value={activeTab ?? undefined}*/}
      {/*  onChange={onSectionChange}*/}
      {/*  className={"[&_.ant-segmented-item]:flex-1"}*/}
      {/*  options={[...projectViewTabs] as SegmentedOptions<ProjectSectionKeys>}*/}
      {/*/>*/}
    </div>
  )
}
